import React, { useEffect, useState } from "react";

import {
  contentCards,
  IContentCardSlim,
  IContentCardsResult,
  isContentCardSlim,
} from "@origin-digital/event-dispatcher";
import { SlimCardWidget } from "@origin-digital/personalisation-widget";
import { Box } from "@origin-digital/ods-core";

export const SlimCard = () => {
  const location = "helpSupport-landing";
  const [cardContent, setCardContent] = useState<IContentCardSlim>();

  useEffect(() => {
    contentCards({ location, limit: 1 }).then(
      ({ cards }: IContentCardsResult) => {
        const [card] = cards;
        if (isContentCardSlim(card)) {
          setCardContent(card);
        }
      }
    );
  }, [location]);

  if (!cardContent) {
    return null;
  }

  return (
    <Box paddingY="xsmall">
      <SlimCardWidget {...cardContent} />
    </Box>
  );
};
